// 创建内存缓存对象 - 使用window对象确保在页面切换时缓存不丢失
if (!window.memoryCache) {
  window.memoryCache = {
    // 存储翻译数据的Map
    translations: new Map(),
    // 存储语言包加载状态
    languageLoaded: false,

    // 获取缓存
    get: function (key) {
      return this.translations.get(key);
    },

    // 设置缓存
    set: function (key, value) {
      this.translations.set(key, value);
    },

    // 批量设置缓存
    setMultiple: function (data) {
      if (typeof data === 'object') {
        Object.keys(data).forEach((key) => {
          this.translations.set(key, data[key]);
        });
      }
    },

    // 检查缓存是否存在
    has: function (key) {
      return this.translations.has(key);
    },

    // 清除缓存
    clear: function () {
      this.translations.clear();
      this.languageLoaded = false;
    }
  };
}

// 获取内存缓存实例
const memoryCache = window.memoryCache;

export default memoryCache;


// WEBPACK FOOTER //
// ./src/utils/cache/memoryCache.js